import React from 'react'
import { Link } from 'react-router-dom'
import ButtonMui from '@mui/material/Button'

const isExternalUrl = href => {
  if (!href) return false
  const url = typeof href === 'string' ? href : href.pathname
  return url && (url.startsWith('http://') || url.startsWith('https://'))
}

const getHrefUrl = href => {
  if (typeof href === 'string') return href
  return href?.pathname || href
}

const Button = ({ href, ...props }) => {
  if (!href) {
    return <ButtonMui {...props} />
  }

  if (isExternalUrl(href)) {
    return <ButtonMui href={getHrefUrl(href)} {...props} />
  }

  return <ButtonMui to={href} component={Link} {...props} />
}

export default Button
